<template>
  <vx-card title="Сообщения">
    <div class="mb-6">
      <IconWithStatistics
        icon="ArrowDownIcon"
        title="От клиентов"
        :count="client_messages_count"
        color="#29c76f"
      />
    </div>
    <div class="mb-6">
      <IconWithStatistics
        icon="ArrowUpIcon"
        title="От операторов"
        :count="operator_messages_count"
        color="#ff9e43"
      />
    </div>
    <div class="mb-6">
      <IconWithStatistics
        icon="HexagonIcon"
        title="От бота"
        :count="bot_messages_count"
        color="#7470e8"
      />
    </div>
    <div class="mb-6">
      <IconWithStatistics
        icon="MessageCircleIcon"
        title="От рассылок"
        :count="bulk_delivery_messages"
        color="#29c76f"
      />
    </div>
    <div>
      <IconWithStatistics
        icon="MessageCircleIcon"
        title="Всего"
        :count="total_messages_count"
        color="#29c76f"
      />
    </div>
  </vx-card>
</template>

<script>
import IconWithStatistics from './IconWithStatistics'

export default {
  props: {
    messages: {
      required: true,
      type: Object
    }
  },

  components: {
    IconWithStatistics
  },

  data () {
    return {
      bot_messages_count: this.messages.bot_messages_count || 0,
      client_messages_count: this.messages.client_messages_count || 0,
      operator_messages_count: this.messages.operator_messages_count || 0,
      bulk_delivery_messages: this.messages.bulk_delivery_messages || 0,
      total_messages_count: this.messages.total_messages_count || 0
    }
  },

  created () {

  },

  methods: {
    getPercent (a) {
      return a * 100 / this.total_messages_count
    }
  }
}
</script>
